export function createSvgFromSvgPath(path) {
    let closedPath;
    if (!path?.toLowerCase().endsWith("z")) {
        closedPath = path + " z";
    }
    else {
        closedPath = path;
    }
    return `<svg xmlns="http://www.w3.org/2000/svg"><path d="${closedPath}"/></svg>`;
}
//# sourceMappingURL=createSvgFromSvgPath.js.map